import { UserToken } from "@/types/auth/user";
import { UserAA, IProfil } from "@/types/userAA";
import { computed, ref } from "vue";
import { refreshToken, getCurrentUser } from "@/api/auth";
import jwtDecode from "jwt-decode";
import { JWT } from "@/types/auth/JWT";
import { useStorage } from "@vueuse/core";
import router from "@/router";

export const currentTokenUser = ref(
  useStorage<UserToken>("usertoken", {} as UserToken),
);
export const currentUser = ref(useStorage<UserAA>("user", {} as UserAA));

export const currentProfil = ref(useStorage<IProfil>("profil", {} as IProfil));

export const changeProfil = (newProfil: IProfil): void => {
  currentProfil.value = newProfil;
};

export const setLogin = (userToken: UserToken): void => {
  currentTokenUser.value = userToken;
  getCurrentUser().then((res) => {
    currentUser.value = res.data;
    currentProfil.value = res.data.profilsADPU.find((p) => {
      return p.isDefaut;
    });
  });
};

// FIXME: appellé dans le router N fois !
export const refreshTokenUser = (): boolean => {
  refreshToken(currentTokenUser.value)
    .then((res) => {
      currentTokenUser.value = res;
      return true;
    })
    .catch(() => {
      logout();
      return false;
    });
  return false;
};

// #NO_AUTH
export const tokenExpirationDate = computed(() => {
  try {
    const decoded: JWT = jwtDecode(currentTokenUser.value.token);
    return (
      new Date(decoded.exp * 1000).toLocaleDateString("fr") +
      " à " +
      new Date(decoded.exp * 1000).toLocaleTimeString("fr")
    );
  } catch (err) {
    return null;
  }
});

// #NO_AUTH
//export const isLoggedIn = computed(() => !!currentTokenUser?.value?.token);
export const isLoggedIn = computed(() => {
  let retour = false;
  if (currentTokenUser?.value?.token) {
    try {
      const decoded = jwtDecode<JWT>(currentTokenUser.value.token);
      console.log("Date Expiration", new Date(decoded.exp * 1000));
      if (Date.now() >= decoded.exp * 1000) {
        console.log("token expiré");
        currentTokenUser.value = null;
        retour = false;
      } else {
        retour = true;
      }
    } catch (err) {
      return false;
    }
  }
  return retour;
});

export const logout = (): void => {
  currentTokenUser.value = null;
  currentUser.value = undefined;
  router.push("/");
};
export const currentReadRights = computed(() => {
  if (isLoggedIn.value) {
    return currentProfil.value.droits.filter((right) => {
      if (right.lecture) {
        return right;
      }
    });
  }
  return [];
});
